import gql from 'graphql-tag';

export const deviceModelFragment = gql`
  fragment deviceModelParts on DeviceModel {
    id
    deviceTypeId
    name
    capabilities
    creationDate
  }
`;

export const deviceTypeFragment = gql`
  fragment deviceTypeParts on DeviceType {
    id
    name
    fieldName
    isCpu
    isController
    creationDate
  }
`;

export const deviceFragment = gql`
  fragment devicePartsForSipConfiguration on Device {
    id
    placeId
    parentDeviceId
    deviceTypeId
    deviceType {
      ...deviceTypeParts
    }
    serialNumber
    ip
    protocolVersion
    firmwareVersion
    name
    isOnline
    serializedParams
    creationDate
    lastUpdate
    updateStatus
    chipsetType
    syncStatus
    immutableData
    deviceModel {
      ...deviceModelParts
    }
  }
  ${deviceModelFragment}
  ${deviceTypeFragment}
`;

export const configuredDeviceFragment = gql`
  fragment configuredDeviceParts on ConfiguredDevice {
    id
    sipAccountId
    typeSip
    status
    url
    sipPassword
    device {
      ...devicePartsForSipConfiguration
    }
    place {
      id
      name
    }
    group {
      id
      name
    }
  }
  ${deviceFragment}
`;

export const configuredAtaFragment = gql`
  fragment configuredAtaParts on ConfiguredAta {
    id
    sipAccountId
    sipPassword
    typeSip
    status
    device {
      ...devicePartsForSipConfiguration
    }
  }
  ${deviceFragment}
`;

export const phoneRegionSettingsOptionFragment = gql`
  fragment phoneRegionSettingsOptionParts on PhoneRegionSettingsOption {
    id
    city
    ddi
    ddd
  }
`;

export const condominiumVirtualPabxFragment = gql`
  fragment condominiumVirtualPabxParts on CondominiumVirtualPabx {
    pabxId
    partnerContextId
    condominiumContextId
    active
    typePabx
    name
    description
  }
`;

export const virtualPabxOperatingScheduleFragment = gql`
  fragment virtualPabxOperatingScheduleParts on VirtualPabxOperatingSchedule {
    id
    daysOfWeek
    startTime
    endTime
    active
  }
`;
